import { Component } from "@angular/core";
import { NavController, NavParams, ViewController } from "ionic-angular";
import { ConfigService } from "../../services/config.service";

@Component({
  selector: "page-privacypolicy",
  templateUrl: "privacypolicy.html"
})
export class PrivacypolicyPage {
  idioma: string;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private configService: ConfigService,
    public viewCtrl: ViewController
  ) {
    this.idioma = this.configService.getIdiom();
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad PrivacypolicyPage");
  }

  ionViewWillEnter() {}
}



// WEBPACK FOOTER //
// ./src/pages/privacypolicy/privacypolicy.ts